import styled from "styled-components";

const StyledIframe = styled.iframe`
    width: 100%;
    height: 80vh;
`;

export default StyledIframe;